import { render, staticRenderFns } from "./HeatmapCapture.vue?vue&type=template&id=47881b1b&scoped=true"
import script from "./HeatmapCapture.vue?vue&type=script&lang=js"
export * from "./HeatmapCapture.vue?vue&type=script&lang=js"
import style0 from "./HeatmapCapture.vue?vue&type=style&index=0&id=47881b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47881b1b",
  null
  
)

export default component.exports